// Task 26 (Architecture D-83): conflicts recorded at booking. A booking may go over something the provider had at
// another location (a PF block such as "Out of office", or another appointment); C-01 marks the row and C-01a lists
// them. Copy from UserFlows C-01 / C-01a.
import type { AppointmentRow } from '@pa/api/clinic'
import { fmtTime } from '@pa/ui'

export const CONFLICT_BADGE = 'Conflict'
/** The badge's accessible name (UserFlows C-01). */
export const CONFLICT_BADGE_NAME = 'Booked over a conflict at another location'
/** The C-01 filter checkbox (UserFlows C-01). */
export const ONLY_CONFLICTS = 'Only with conflicts'
/** The C-01a section (UserFlows C-01a). */
export const CONFLICTS_TITLE = 'Conflicts at booking'
export const CONFLICTS_NOTE =
  'The provider had this at another location when the patient booked. Check it in Practice Fusion.'

export type Conflict = AppointmentRow['conflicts'][number]

/** "Out of office · Pasadena Clinic · 8:00 AM – 12:00 PM", times in the clinic's zone (UserFlows C-01a). */
export function conflictLine(c: Conflict, timeZone: string): string {
  return `${c.reason} · ${c.location} · ${fmtTime(c.start, timeZone)} – ${fmtTime(c.end, timeZone)}`
}

export const hasConflicts = (row: Pick<AppointmentRow, 'conflicts'>): boolean => row.conflicts.length > 0
